import {
  ACT_INSTANCES_FETCH_PRODUCTS_INIT_ACTION,
  ACT_INSTANCES_FETCH_PRODUCTS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_GET_PRODUCT_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_ADD_PRODUCT_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_DELETE_PRODUCT_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_PRODUCTS_FILTERS,
  ACT_INSTANCES_SET_SELECTED_PRODUCT,
} from '../../constants/actions';

export const fetchProductsInitAction = () => ({
  type: ACT_INSTANCES_FETCH_PRODUCTS_INIT_ACTION,
});

export const fetchProductsSuccessAction = data => ({
  type: ACT_INSTANCES_FETCH_PRODUCTS_SUCCESS_ACTION,
  payload: data,
});

export const getProductInitAction = () => ({
  type: ACT_INSTANCES_GET_PRODUCT_INIT_ACTION,
});

export const getProductSuccessAction = data => ({
  type: ACT_INSTANCES_GET_PRODUCT_SUCCESS_ACTION,
  payload: data,
});

export const addProductInitAction = data => ({
  type: ACT_INSTANCES_ADD_PRODUCT_INIT_ACTION,
  payload: data,
});

export const addProductSuccessAction = data => ({
  type: ACT_INSTANCES_ADD_PRODUCT_SUCCESS_ACTION,
  payload: data,
});

export const deleteProductInitAction = id => ({
  type: ACT_INSTANCES_DELETE_PRODUCT_INIT_ACTION,
  payload: id,
});

export const deleteProductSuccessAction = () => ({
  type: ACT_INSTANCES_DELETE_PRODUCT_SUCCESS_ACTION,
});

export const updateProductFiltersAction = filters => ({
  type: ACT_INSTANCES_UPDATE_PRODUCTS_FILTERS,
  payload: filters,
});

export const updateSelectedProductAction = component => ({
  type: ACT_INSTANCES_SET_SELECTED_PRODUCT,
  payload: component,
});
